module.exports = __webpack_public_path__ + "img/maoli_nav.fdd41a98.png";